import {Col, Row, Spinner} from 'react-bootstrap'
import {KTCard} from '../../../_metronic/helpers'
import {GET_LIVE_AGENT_QUESTIONS, SAVE_ANSWER} from '../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import {useEffect, useState, useRef} from 'react'
import {alert} from '../../../utils/helper'
import moment from 'moment'
const Questions = ({
  pincode,
  setPincode,
  index,
  setIndex,
  setIsVerified,
  details,
  customerName,
  invertrulesBgColor,
  onComplete,
  cardClassName = '',
  rulesSection,
  isFlagged = null,
}: any) => {
  const [elapsedTime, setElapsedTime] = useState<number>(0)
  const countRef = useRef<any>(null)
  const handleTimerStart = () => {
    const startTime = Date.now() - elapsedTime
    countRef.current = setInterval(() => {
      setElapsedTime(Date.now() - startTime)
    }, 10)
  }
  const startTime = useRef<any>(0)
  //queries
  const [getQuestion, {loading, data: question}] = useLazyQuery(GET_LIVE_AGENT_QUESTIONS, {
    onCompleted: () => (startTime.current = new Date()),
    fetchPolicy: 'network-only',
  })
  const [saveAnswer] = useMutation(SAVE_ANSWER, {
    onCompleted: (data) => {
      if (!data.saveAnswerByPin.isCompleted) {
        setIndex(index + 1)
      } else {
        alert('Thank you for calling TPV solutions, Goodbye', 'success')
        setIsVerified(false)
        setIndex(0)
        Boolean(setPincode) && setPincode('')
        clearInterval(countRef.current)
        setElapsedTime(0)
        Boolean(onComplete) && onComplete()
      }
    },
    onError: (err) => {
      console.log('hello this is saveanswer error', err)
      alert(err.message, 'error')
    },
    fetchPolicy: 'network-only',
  })
  const [isYes, setIsYES] = useState(false)
  const [isNO, setIsNo] = useState(false)
  const [answer, setAnswer] = useState('')
  useEffect(() => {
    if (index !== 0) {
      setIsYES(false)
      setAnswer('')
      setIsNo(false)
      getQuestion({
        variables: {
          pincode: String(pincode),
          index: index,
        },
      })
      if (index === 1) {
        handleTimerStart()
      }
    }
  }, [getQuestion, index, pincode])
  const handleSubmit = () => {
    const answerInput = {
      questionId: question?.getLiveAgentQuestionsByPin?.questionId,
      questionDescription: question?.getLiveAgentQuestionsByPin?.questionDescription,
      questionType: question?.getLiveAgentQuestionsByPin?.questionType,
      recordingStartedAt: startTime.current,
      isLastQuestion: question?.getLiveAgentQuestionsByPin?.isLastQuestion,
    }

    if (question?.getLiveAgentQuestionsByPin?.questionType === 'SPEECH_ONLY') {
      saveAnswer({
        variables: {
          pincode,
          answerInput: {...answerInput, description: '', recordingEndAt: new Date()},
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'VOICE_RESPONSE') {
      saveAnswer({
        variables: {
          pincode,
          answerInput: {...answerInput, description: answer, recordingEndAt: new Date()},
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'YESNO') {
      saveAnswer({
        variables: {
          pincode,
          answerInput: {
            ...answerInput,
            description: isYes ? 'yes.' : 'no.',
            recordingEndAt: new Date(),
          },
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'DTMF') {
      saveAnswer({
        variables: {
          pincode,
          answerInput: {...answerInput, description: answer, recordingEndAt: new Date()},
          isFlagged,
        },
      })
    } else if (question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION') {
      if (isYes || isNO) {
        saveAnswer({
          variables: {
            pincode,
            answerInput: {
              ...answerInput,
              description: isYes ? 'yes.' : 'no.',
              recordingEndAt: new Date(),
            },
            isFlagged,
          },
        })
      } else {
        saveAnswer({
          variables: {
            pincode,
            answerInput: {...answerInput, description: answer, recordingEndAt: new Date()},
            isFlagged,
          },
        })
      }
    }
  }

  return (
    <>
      <KTCard className='my-4 py-2 w-100 text-center'>
        <div className='flex-column justify-content-center  align-items-center border-0'>
          {Boolean(details?.clientName) && (
            <div className='card-title'>
              <h4 className='fs-3'>{customerName}</h4>
            </div>
          )}
          <h6 className='mb-0'>
            Call Time : {moment.duration(elapsedTime).hours()}
            {moment.duration(elapsedTime).minutes()}:
            {moment.duration(elapsedTime).seconds() < 10 && '0'}
            {moment.duration(elapsedTime).seconds()}
          </h6>
        </div>
      </KTCard>
      {Boolean(rulesSection) && rulesSection}
      <KTCard className={`${cardClassName}`}>
        <div className=' flex-column justify-content-center  align-items-center pb-0 border-0'>
          <div className='d-flex flex-column w-100'>
            <div className='bg-f4f4f4 p-5 mb-7 rounded-3'>
              <div className='d-flex flex-column gap-4 '>
                <div className='d-flex flex-row'>
                  <h5 className='fs-3 me-4 text-gray-600'>Question</h5>
                  <div
                    className='bg-gray-700  p-2 w-30px h-30px text-center text-white'
                    style={{borderRadius: '6px'}}
                  >
                    {index}
                  </div>
                </div>

                <div className=''>
                  {loading ? (
                    <div className='text-center'>
                      <Spinner animation='border' className='text-gray-600' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <>
                      <h6 className='w-100 fs-3'>
                        {question?.getLiveAgentQuestionsByPin?.questionDescription ?? 'question'}
                      </h6>
                      {(question?.getLiveAgentQuestionsByPin?.questionType === 'YESNO' ||
                        question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION') && (
                        <div className='form-check form-check-script form-check-custom form-check-solid mt-7'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            checked={isYes}
                            id='YESNO'
                            onChange={() => {
                              if (
                                question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION'
                              ) {
                                setAnswer('')
                                setIsYES(!isYes)
                                setIsNo(false)
                              } else {
                                setIsYES(!isYes)
                                setIsNo(false)
                              }
                            }}
                          />
                          <label className='form-check-label' htmlFor='YES'>
                            Yes
                          </label>
                          <input
                            className='form-check-input ms-5'
                            type='checkbox'
                            id='DTMF'
                            checked={isNO}
                            onChange={() => {
                              if (
                                question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION'
                              ) {
                                setAnswer('')
                                setIsNo(!isNO)
                                setIsYES(false)
                              } else {
                                setIsNo(!isNO)
                                setIsYES(false)
                              }
                            }}
                          />
                          <label className='form-check-label' htmlFor='DTMF'>
                            No
                          </label>
                        </div>
                      )}
                      {(question?.getLiveAgentQuestionsByPin?.questionType === 'DTMF' ||
                        question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION') && (
                        <div>
                          <label className={`d-flex align-items-center mb-2 mt-3`}>
                            <div className='fs-6 fw-semibold lh-23px'>Other</div>
                          </label>
                          <input
                            id='other'
                            type='text'
                            className='form-control form-control-lg form-control-solid bg-white'
                            name='other'
                            value={answer}
                            placeholder='Enter Answer'
                            onChange={(e) => {
                              if (
                                question?.getLiveAgentQuestionsByPin?.questionType === 'BOTH_OPTION'
                              ) {
                                setAnswer(e.target.value)
                                setIsNo(false)
                                setIsYES(false)
                              } else {
                                setAnswer(e.target.value)
                              }
                            }}
                          />
                        </div>
                      )}

                      {question?.getLiveAgentQuestionsByPin?.questionType === 'VOICE_RESPONSE' && (
                        <div>
                          <label className={`d-flex align-items-center mb-2 mt-3`}>
                            <div className='fs-6 fw-semibold lh-23px'>Voice Response</div>
                          </label>
                          <input
                            id='other'
                            type='text'
                            className='form-control form-control-lg form-control-solid bg-white'
                            name='other'
                            value={answer}
                            placeholder='Enter Answer'
                            onChange={(e) => {
                              if (
                                question?.getLiveAgentQuestionsByPin?.questionType ===
                                'VOICE_RESPONSE'
                              ) {
                                setAnswer(e.target.value)
                                setIsNo(false)
                                setIsYES(false)
                              } else {
                                setAnswer(e.target.value)
                              }
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <button
              className='btn btn-primary mw-150px align-self-center'
              onClick={() => handleSubmit()}
            >
              Continue
            </button>
          </div>
        </div>
      </KTCard>
    </>
  )
}
export default Questions
